import { useEffect, useState } from 'react';

let selectedCoverageComboId;

const listeners = new Set();

const notify = () => {
  listeners.forEach((listener) => listener());
};

export const coverageComboStore = {
  getId: () => selectedCoverageComboId,
  setId: (id) => {
    const nextId = id ?? undefined;
    if (selectedCoverageComboId === nextId) return;
    selectedCoverageComboId = nextId;
    notify();
  },
  clear: () => {
    if (selectedCoverageComboId === undefined) return;
    selectedCoverageComboId = undefined;
    notify();
  },
  subscribe: (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export const syncCoverageComboFromDataCoverage = (dataCoverage) => {
  coverageComboStore.setId(dataCoverage?.id_coverage_combo);
};

export const useSelectedCoverageComboId = () => {
  const [id, setId] = useState(() => coverageComboStore.getId());

  useEffect(() => coverageComboStore.subscribe(() => setId(coverageComboStore.getId())), []);

  return id;
};
